import { SITE } from '@/lib/site'
import { SITE_STATS } from '@/data/siteStats'
import type { ApiSiteSettings, SiteConfig } from '@/types/settings'

function or<T>(value: T | null | undefined, fallback: T): T {
  if (value === null || value === undefined || value === '') return fallback
  return value
}

export function mergeSiteSettings(api?: ApiSiteSettings | null): SiteConfig {
  const contact = api?.contact
  const social = contact?.social

  return {
    name: SITE.name,
    legalName: SITE.legalName,
    logo: SITE.logo,
    // Call / WhatsApp / email are fixed brand contacts (not overridden by stale admin settings).
    phone: SITE.phone,
    phoneTel: SITE.phoneTel,
    whatsapp: SITE.whatsapp,
    whatsappLink: contact?.whatsappLink ?? null,
    email: SITE.email,
    emailAlt: SITE.emailAlt,
    address: or(contact?.address, SITE.address),
    website: contact?.website ?? null,
    footerBg: SITE.footerBg,
    social: {
      facebook: or(social?.facebook, SITE.social.facebook),
      instagram: or(social?.instagram, SITE.social.instagram),
      youtube: or(social?.youtube, SITE.social.youtube),
      linkedin: or(social?.linkedin, SITE.social.linkedin),
      twitter: or(social?.twitter, SITE.social.linkedin),
    },
    apps: SITE.apps,
    stats: {
      totalSellProperty: api?.stats?.totalSellProperty ?? null,
    },
    heroStats: {
      appDownloads: or(api?.heroStats?.appDownloads, SITE_STATS.appDownloads),
      activeUsers: or(api?.heroStats?.activeUsers, SITE_STATS.activeUsers),
      brokerageSaved: or(api?.heroStats?.brokerageSaved, SITE_STATS.brokerageSaved),
      verifiedProperties: or(api?.heroStats?.verifiedProperties, SITE_STATS.verifiedProperties),
      whatsappGroups: or(api?.heroStats?.whatsappGroups, SITE_STATS.whatsappGroups),
    },
    links: api?.links ?? {
      website: null,
      calculator: null,
      book: null,
      premiumBenefits: null,
      premiumBenefit: null,
      agentRegister: null,
      premiumRegister: null,
      catalog: null,
      ecommerce: null,
      redeemHistory: null,
    },
    coins: api?.coins ?? {
      price: null,
      oneTimeGiven: null,
      oneTimeTaken: null,
    },
    raw: api?.settings ?? {},
  }
}

export function whatsappHref(number: string, message?: string): string {
  const base = `https://wa.me/${number}`
  if (!message) return base
  return `${base}?text=${encodeURIComponent(message)}`
}
